export const secondsToTime = (seconds: number) => {
  if (!seconds) return '00:00';

  const date = new Date(seconds * 1000);
  const isoString = date.toISOString();

  // If beyond an hour, we should return HH:MM:SS
  if (date.getUTCHours() > 0) {
    return isoString.substring(11, 19); // HH:MM:SS
  } else {
    return isoString.substring(14, 19); // MM:SS
  }
};
